<template>
  <div class="login">
    <div class="home_title">
      ingresa a tu cuenta
    </div>
    <form v-on:keyup.enter="login()">
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12">
          <v-text-field
            filled
            :error-messages="userErrors"
            @change="$v.user.$touch()"
            @blur="$v.user.$touch()"
            label="Usuario"
            @focus="$v.user.$reset()"
            v-model="user"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12">
          <v-text-field
            :type="showPass ? 'text' : 'password'"
            :error-messages="passwordErrors"
            @change="$v.password.$touch()"
            @blur="$v.password.$touch()"
            filled
            @focus="$v.password.$reset()"
            label="Contraseña"
            v-model="password"
            :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPass = !showPass"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <a class="forgot_password" :href="forgotPasswordUrl" target="_blank">
            Olvidé mis datos de acceso
          </a>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn
            block
            color="primary"
            class="uppercase"
            @click="login"
            :loading="loading"
          >
            Ingresar
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="home_info">
          <div class="icon_info">
            <v-icon small>info</v-icon>
          </div>
          <div>
            Ingresa con los datos de alumno o egresado de la Universidad del
            Pacífico
          </div>
        </v-col>
      </v-row>
    </form>
  </div>
</template>
<script>
import { required, maxLength, email } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      user: null,
      password: null,
      showPass: false,
      loading: false,
      forgotPasswordUrl: "https://srvnetappseg.up.edu.pe/siserpwd/"
    };
  },
  validations() {
    return {
      user: {
        required,
        maxLength: maxLength(100)
      },
      password: {
        required
      },
      emailUser: {
        email
      }
    };
  },
  methods: {
    login() {},
    showRecoverPassword() {
      window.open("https://srvnetappseg.up.edu.pe/siserpwd/");
    }
  },
  computed: {
    userErrors() {
      const errors = [];
      if (!this.$v.user.$dirty) return errors;
      !this.$v.user.required && errors.push("Usuario es requerido");
      !this.$v.user.maxLength &&
        errors.push("El usuario no puede tener mas de 100 caracteres");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("Contraseña es requerida");
      return errors;
    }
  }
};
</script>
